import React from 'react';
import FormModal from "../../../components/common/modals/FormModal";
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewFacilityVersionModal = ({showModal, onClose, facilityId}) => {
    const mutation = graphql`
    mutation NewFacilityVersionModalMutation($facilityId: ID!, $name: String!, $nickName: String!, 
    $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
        facility {
            createVersion(input: {name: $name, nickName: $nickName, effectiveFrom: $effectiveFrom, 
              effectiveTo: $effectiveTo, facilityId: $facilityId}) {
                facilityVersion {
                    id
                    facility {
                        versions {
                            ...FacilityVersions_Versions
                        }
                        applicableVersion {
                            id
                        }}}}}}`
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        facilityId: facilityId,
        name: '',
        nickName: '',
    }
    const schema = bandedSchema.shape({
        name: yup.string().required("Name is required")
    });
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({
            variables: {...data}, onCompleted: (data) => {
                if (data.facility) {
                    toast.success("Version for Facility created")
                    methods.reset();
                    onClose();
                }
            }
        })
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Version"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormInput controlId={"name"} label={"Name"}/>
            <HorizontalFormInput controlId={"nickName"} label={"Nick Name"}/>
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"}/>
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"}/>
        </FormModal>
    )
}
NewFacilityVersionModal.propTypes = {}
export default NewFacilityVersionModal